export enum PermissionRoles {
  GG_RO_HQ_SHOP_RECEPTION_DIRECTOR = 'GG_RO_HQ_SHOP_RECEPTION_DIRECTOR',
  GG_RO_HQ_SHOP_RECEPTION_STORE = 'GG_RO_HQ_SHOP_RECEPTION_STORE',
  GG_RO_HQ_SHOP_RECEPTION_BACKOFFICE = 'GG_RO_HQ_SHOP_RECEPTION_BACKOFFICE',
  GG_RO_HQ_SHOP_RECEPTION_ADMIN = 'GG_RO_HQ_SHOP_RECEPTION_ADMIN',
  GG_RO_HQ_SHOP_RECEPTION_REGIONAL_OPERATIONS = 'GG_RO_HQ_SHOP_RECEPTION_REGIONAL_OPERATIONS'
}

export enum Mark {
  VEGETABLES_FRUITS = 'Legume fructe',
  DAMAGED = 'Deteriorate',
  SHORT_TERM = 'Termen Scurt',
  EXPIRED = 'Expirate',
  VEGETABLE_FRUIT_QUALITY = 'Calitate legume fructe',
  DETERIORATION_A = 'Deteriorare-A',
  QUANTITATIVE_DIFFERENCE_A = 'Diferenta cantitativa-A',
  MISSING_BAX = 'Lipsa Bax',
  QUANTITATIVE_DIFFERENCE = 'Diferenta cantitativa',
  MISSING_CARRIER = 'Lipsa transportator',
  PALLETS_MERCHANDISE_MISSING = 'Paleti marfa lipsa',
  VOLUME = 'VOL'
}

export enum DefectReason {
  PROVIDER = 'Prestator',
  TRANSPORTER = 'Transportator',
  SHOP = 'Sef depozit'
}

export enum ProductType {
  INTEGRAL = 'Integral',
  SENSIBLE_PRODUCTS = 'Produse sensibile',
  ALEATORY = 'Suport aleator',
  ALEATORY_PRODUCT = 'Produs aleator',
  NONE = 'Nici un produs',
  SENSIBLE_SHORT_DLC_PRODUCTS = 'Produse cu DLC scurt'
}

export enum ScanStatus {
  CODE_AND_EAN_NOT_PRESENT = 'CODE_AND_EAN_NOT_PRESENT',
  EAN_NOT_PRESENT = 'EAN_NOT_PRESENT'
}

export enum statusColorMapping {
  REGISTERED = 'orange',
  IN_PROGRESS = 'blue',
  IN_PROCESS = 'blue',
  PROCESSED = 'green',
  PARTIALLY_SENT_TO_METI = 'blue',
  SENT_TO_METI = 'green',
  RESEALED = 'orange',
  HUB_REGISTERED = 'orange',
  HUB_IN_PROGRESS = 'blue',
  HUB_MISSING = 'red',
  SUCCESS = 'green',
  MISSING = 'red',
  WAITING = 'black',
  REQUESTED = 'orange',
}
